import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { commonSubtitleText } from 'src/modules/utils/constants'
import styled from 'styled-components'

export default (props) => {
  return (
    <StyledContainer>
      <USTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        poster={`https://assets-imgx.fubo.tv/marketing/lp/images/posters/CBS-Evergreen_web-v2.jpg`}
        posterMobile={`https://assets-imgx.fubo.tv/marketing/lp/images/posters/CBS-Evergreen_mobile-v2.jpg`}
        title="Stream CBS with Fubo"
        subtitle={commonSubtitleText.onAnyDevice}
        showRedzone={false}
        // TEMPORARY NBC DISPUTE
        // customNetworks={['cbs', 'abc', 'fox', 'nbc', 'espn', 'fx', 'fs1']}
        customNetworks={['cbs', 'abc', 'fox', 'espn', 'fx', 'fs1']}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div``
